import { useEffect, useState } from "react";
import { Truck, Pill, Users } from "lucide-react";
import api from "@/lib/api";

export const PartnerLeadsCounter = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/leads/partners/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats) return null;
  const pct = Math.min(100, Math.round((stats.total / stats.target) * 100));
  return (
    <div className="mt-6 bg-white/80 backdrop-blur border border-slate-200 rounded-2xl p-4 max-w-md" data-testid="partner-leads-counter">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Users className="h-4 w-4 text-[#FF7A5C]" />
          <span className="font-display font-extrabold text-deep text-lg" data-testid="partner-leads-total">{stats.total}</span>
          <span className="text-sm text-slate-600">{stats.total > 1 ? "structures déjà pré-inscrites" : "structure déjà pré-inscrite"}</span>
        </div>
        <span className="text-xs text-slate-400">objectif {stats.target}</span>
      </div>
      <div className="mt-2 h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-emerald-500 to-[#FF7A5C] transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-2 flex gap-4 text-xs text-slate-600">
        <span className="flex items-center gap-1" data-testid="partner-leads-transport"><Truck className="h-3.5 w-3.5 text-emerald-600" />{stats.transport} transport{stats.transport > 1 ? "s" : ""}</span>
        <span className="flex items-center gap-1" data-testid="partner-leads-pharmacy"><Pill className="h-3.5 w-3.5 text-[#FF7A5C]" />{stats.pharmacy} pharmacie{stats.pharmacy > 1 ? "s" : ""}</span>
        {stats.total < stats.target && <span className="ml-auto text-slate-400">plus que {stats.target - stats.total} place{stats.target - stats.total > 1 ? "s" : ""}</span>}
      </div>
    </div>
  );
};
